"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_ASSISTANT_PAGE_HINTS = void 0;
exports.PUBLIC_ASSISTANT_PAGE_HINTS = ["login", "register", "marketing", "pricing", "help"];
